import { HtmlTable } from '../../../../../../../../../CommonComponents/OPL/HtmlTable/HtmlTable';
import styled from '../../../../../../../../../theme/theme';

export const StyledHtmlTable = styled(HtmlTable)(({ theme }) => ({
  width: 'auto',
  margin: `0 ${theme.space[16] * -1}px`,
  table: {
    tableLayout: 'fixed',
  },
}));
